import React, { ReactElement } from 'react';
import NotificationPanel from './NotificationPanel';
// import { ReactComponent as NotificationIcon } from '../../../assets/images/svg/i_notification.svg';
import animationData from '../../../assets/images/lottie-json/i_notification.json';
import { readNotifications, saveNotifications, updateUnreadAndTotalCount } from '../../../store/actions/utilAction';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import Lottie from 'react-lottie';

export interface Notification {
  notificationMessageId: number;
  hospActionId: number;
  payerClaimNo: string;
  providerId: number;
  payerId: number;
  title: string;
  content: string;
  imagePath: string;
  tags: string[];
  messageCreatedOn: string;
  isRead: boolean;
}

interface INotificationProps {
  isNotificationPanelVisible: boolean;
  onClose: () => void;
  handleOpenNotificationPanel: () => void;
  totalNotificationUnReadCount: number;
  isStopped: boolean;
  isPaused: boolean;
  unreadNotificationsList: any[];
  setUnreadNotificationsList: any;
}

const Index = ({
  onClose,
  handleOpenNotificationPanel,
  isNotificationPanelVisible,
  totalNotificationUnReadCount,
  isStopped,
  isPaused,
  unreadNotificationsList,
  setUnreadNotificationsList,
}: INotificationProps): ReactElement => {
  const dispatch = useDispatch();
  const { notifications } = useSelector(
    (state: RootState): any => state.util,
  ) || [];

  const handleMarkAllAsRead = (): void => {
    dispatch(readNotifications([], onSuccessRead, (): void => { }, true));
    dispatch(updateUnreadAndTotalCount(0));
  };

  const onSuccessRead = (): void => {
    dispatch(saveNotifications(notifications?.map((ele: any): any => {
      return {
        ...ele,
        isRead: true,
      };
    }), false));
  };

  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <>
      {isNotificationPanelVisible && (
        <NotificationPanel
          handleMarkAllAsRead={handleMarkAllAsRead}
          isNotificationPanelVisible={isNotificationPanelVisible}
          onClose={onClose}
          unreadNotificationsList={unreadNotificationsList}
          setUnreadNotificationsList={setUnreadNotificationsList}
        />
      )}
      <div className="lottie-icon" onClick={handleOpenNotificationPanel}>
        <Lottie options={defaultLottieOptions} isStopped={isStopped} isPaused={isPaused} />
      </div>
      {Boolean(totalNotificationUnReadCount) && localStorage.getItem('isNotificationEnabled') === 'true' && (
        <div className={'notify-number'} />
      )}
    </>
  );
};

export default Index;
